import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';

import { tabs } from './tabs';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { PAGE_TYPE, PageType } from './service/tabs.interface';
import {
    selectAnalyticsFilters,
    updateFilters,
} from '../../store/analyticFiltersSlice';
import { tabMap } from '../../features/AnalyticsFilters/utils/tab';
import { initialFilters } from '../../features/AnalyticsFilters/utils/filters';

export const TabSwitcher = () => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const dispatch = useAppDispatch();

    const [tab, setTab] = useState<PageType>(PAGE_TYPE.MANAGE);

    useEffect(() => {
        const nextTab =
            (filters?.is_user_bot_source && tabMap['is_user_bot_source']) ||
            (filters?.is_chat_bot_source && tabMap['is_chat_bot_source']);

        if (nextTab) {
            setTab(nextTab);
        }
    }, [tabMap, filters?.is_user_bot_source, filters?.is_chat_bot_source]);

    const changeTab = (currentTab: PageType) => {
        dispatch(updateFilters(initialFilters));

        const newFilters: Record<string, boolean> = {
            is_chat_bot_source: undefined,
            is_user_bot_source: undefined,
        };

        if (currentTab === PAGE_TYPE.MANAGE) {
            newFilters.is_chat_bot_source = true;
        }

        if (currentTab === PAGE_TYPE.MONITORING) {
            newFilters.is_user_bot_source = true;
        }

        dispatch(updateFilters(newFilters));
    };

    return (
        <Tabs
            activeKey={tab}
            onChange={tab => changeTab(tab as PageType)}
            items={tabs}
        />
    );
};
